import { TableHead } from '@mui/material';
import styled from 'styled-components';

export const CustomTableHead = styled(TableHead)`
  & .MuiTableCell-root {
    background-color: var(--color-blue-primary);
  }
`;
